import { render, staticRenderFns } from "./ModifyCustomerApproval.vue?vue&type=template&id=4dfc4246"
import script from "./ModifyCustomerApproval.vue?vue&type=script&lang=js"
export * from "./ModifyCustomerApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports